import { Checkbox } from 'ui/checkboxV2';
import { FormField } from 'ui/formField';
import { Subtitle1, H4 } from 'ui/theme';
import { MultiSelect } from 'ui/selectv2/MultiSelect';
import { Spinner } from 'ui/spinner';
import { ErrorStateEditError } from 'ui/illustrations';
import { CenteredLoadingWrapper } from './styles';
import {
  BodyContent,
  StyledRadioGroup,
  TakeoverBodyHeader,
  ErrorStateWrapper,
  ErrorStateBody,
} from './styles';
import { ExpandingWrapper } from '../AnonymousUserTracking.styled';
import { useCriteriaRetentionContext } from './CriteriaRetentionContext';
import { RETENTION_PERIOD_OPTIONS, CONTENT, MULTI_SELECT_OPTION_LIMIT } from './constants';

export const CriteriaRetentionBody = () => {
  const {
    isLoadingSettings,
    hasCriteriaSettingsError,
    isRetentionEnabled,
    setIsRetentionEnabled,
    selectedRetentionOption,
    handleSelect,
    selectedListOptions,
    handleListSelection,
    listOptions,
    isLoadingLists,
    hasListsError,
    listsErrorMessage,
  } = useCriteriaRetentionContext();

  return (
    <div>
      <TakeoverBodyHeader>
        <Subtitle1>{CONTENT.header.retentionPeriod}</Subtitle1>
      </TakeoverBodyHeader>
      {isLoadingSettings ? (
        <CenteredLoadingWrapper>
          <Spinner />
        </CenteredLoadingWrapper>
      ) : hasCriteriaSettingsError ? (
        <ErrorStateWrapper>
          <ErrorStateEditError height={80} width={80} />
          <H4>{CONTENT.errors.settingsLoadError}</H4>
          <ErrorStateBody>{CONTENT.errors.genericError}</ErrorStateBody>
        </ErrorStateWrapper>
      ) : (
        <BodyContent>
          <FormField data-test="enable-retention-period" inputId="enableRetentionPeriod">
            <Checkbox
              id="enable-retention-period"
              label={CONTENT.form.enableRetentionLabel}
              DescriptionText={CONTENT.form.enableRetentionDescription}
              status={isRetentionEnabled}
              setChecked={(checked) => {
                setIsRetentionEnabled(checked as boolean);
              }}
            />
          </FormField>
          {isRetentionEnabled && (
            // Render retention options only if enabled
            <>
              {/* Retention Period */}
              <FormField
                data-test="retention-period"
                inputId="retentionPeriod"
                labelText={CONTENT.form.retentionPeriodLabel}
                descriptionText={CONTENT.form.retentionPeriodDescription}
              >
                <StyledRadioGroup
                  name="RetentionPeriodSelectionRadioGroup"
                  onSelect={handleSelect}
                  options={RETENTION_PERIOD_OPTIONS}
                  radioAlignment="flex-start"
                  value={selectedRetentionOption}
                />
              </FormField>
              {/* Exclude Users */}
              <FormField
                data-test="exclude-user-lists"
                inputId="excludeUserLists"
                labelText={CONTENT.form.excludeUsersLabel}
                descriptionText={CONTENT.form.excludeUsersDescription}
              >
                {isLoadingLists ? (
                  <ExpandingWrapper>
                    <Spinner />
                  </ExpandingWrapper>
                ) : hasListsError ? (
                  <ErrorStateWrapper>
                    <ErrorStateEditError height={60} width={60} />
                    <H4>{CONTENT.errors.listsLoadError}</H4>
                    <ErrorStateBody>
                      {listsErrorMessage?.message || CONTENT.errors.listsGenericError}
                    </ErrorStateBody>
                  </ErrorStateWrapper>
                ) : (
                  <MultiSelect
                    id="exclude-user-list-multi-select"
                    optionLimit={MULTI_SELECT_OPTION_LIMIT}
                    options={listOptions}
                    onSelect={handleListSelection}
                    placeholder={CONTENT.form.multiSelectPlaceholder}
                    value={selectedListOptions}
                    defaultValue={selectedListOptions}
                  />
                )}
              </FormField>
            </>
          )}
        </BodyContent>
      )}
    </div>
  );
};
